// Application constants for Cleancy Web App

// User status constants
export const UserStatus = {
  guest: 0,
  user: 1,
  admin: 2,
  deleted: 3,
  virtual: 4,
};

// Google Maps configuration
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

// Google Cloud Storage URL for avatars (same as used for report images)
export const STATIC_URL = "https://storage.googleapis.com/cleancy-uploads/";

// Default map coordinates and zoom level
export const DEFAULT_LAT = 61.0;
export const DEFAULT_LNG = 105.0;
export const DEFAULT_ZOOM = 3;

// Map configuration
export const MAP_CONFIG = {
  // Required for Advanced Markers
  MAP_ID: "DEMO_MAP_ID",

  // Minimum zoom the map can ever show. Floors both fitBounds (when reports
  // span the globe) and manual zoom-out, so the world map always fills the
  // viewport — without it, a tall viewport (e.g. the Telegram Mini App) shows
  // empty map background above/below at very low zoom. Tune if needed.
  MIN_ZOOM: 3,

  // Maximum zoom level when fitting bounds
  MAX_ZOOM_ON_FIT_BOUNDS: 15,

  // Minimum zoom level when selecting a report
  MIN_ZOOM_ON_SELECT: 5,
};

// Clustering configuration (mirrors the cleancy mobile app's mapClustering.ts)
export const CLUSTER_CONFIG = {
  // Pixel radius supercluster uses to merge nearby points into a cluster.
  // Sized wider than a marker so pins that would overlap merge instead of
  // hiding each other.
  RADIUS: 70,
  // Stop clustering at/above this zoom — individual pins show beyond it.
  MAX_ZOOM: 17,
  // Minimum points required to form a cluster.
  MIN_POINTS: 2,
  // Debounce (ms) applied to the map `idle` event before recomputing clusters.
  IDLE_DEBOUNCE_MS: 150,
};

// API configuration
export const API_CONFIG = {
  // Retry timeout for failed requests (in milliseconds)
  RETRY_TIMEOUT: 5000,

  // Cold-start cache (status-only pins) persisted to localStorage so a page
  // reload paints pins instantly before the network responds.
  REPORTS_CACHE_KEY: "cleancy:reports-cache:v3",
  CACHE_VERSION: 3,

  // Preview lazy-load batching (POST /reports/bulk accepts <= 100 ids).
  PREVIEW_BATCH_SIZE: 40,
  PREVIEW_MAX_CONCURRENT: 3,

  // Coalesce window (ms) for status-only re-syncs triggered by mutations.
  SYNC_COALESCE_MS: 200,
};

// UI configuration
export const UI_CONFIG = {
  // Sidebar collapse states
  SIDEBAR_COLLAPSED_WIDTH: 60,
  SIDEBAR_EXPANDED_WIDTH: 400,

  // Animation timings
  FADE_IN_DURATION: 300,
  SCROLL_ANIMATION_DURATION: 500,
};

export const API_VERSION = "3";

export const MAX_MESSAGE_LENGTH = 500;

// Max images per report/cleanup. Mirrors the server's MAX_DIRECT_UPLOAD_FILES;
// enforce it at selection time so users never hit the upload-time rejection.
export const MAX_REPORT_IMAGES = 5;
